import React from 'react';
import { get } from 'lodash';

import CardListingPreview from './Card';
import SimpleListingPreview from './Simple';

export interface Props {
  allowFavorite: boolean;
  cardFormat?: boolean;
  compact?: boolean;
  investment?: boolean;
  listing: any;
  multiFamily?: boolean;
  onCardSelect?: Function;
  selected?: boolean;
  photosByRoom?: string;
  disableImageSlider?: boolean;
}
export const ListingPreview: React.FC<Props> = props => {
  const previewContent = get(props, 'cardFormat', true) ? (
    <CardListingPreview
      allowFavorite={props.allowFavorite}
      compact={props.compact}
      investment={props.investment}
      listing={props.listing}
      onCardSelect={props.onCardSelect}
      selected={props.selected}
      photosByRoom={props.photosByRoom}
      disableImageSlider={props.disableImageSlider}
    />
  ) : (
    <SimpleListingPreview listing={props.listing} />
  );

  return previewContent;
};

export default ListingPreview;
